import React from "react";
import { useNavigate } from "react-router-dom";
import SettingsRemoteOutlinedIcon from "@mui/icons-material/SettingsRemoteOutlined";
import { SecondaryActionButton, StandardPageHeader } from "app/shared/ui";

// Cabecera de la vista Automatizaciones, en la lista y en los editores.
const AutomationsHeader = ({ actions = null }) => {
    const navigate = useNavigate();

    return (
        <StandardPageHeader
            title="Automatizaciones"
            subtitle="Diseña flujos claros para monitorear, notificar y actuar sobre tus dispositivos."
            actions={(
                <>
                    <SecondaryActionButton
                        onClick={() => navigate("/automations/notifications")}
                        startIcon={<SettingsRemoteOutlinedIcon />}>
                        Ver historial de notificaciones
                    </SecondaryActionButton>
                    {actions}
                </>
            )}
        />
    );
};

export default AutomationsHeader;
